module.exports = __webpack_public_path__ + "static/media/mobileLandingPage.466fb921.png";